<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title text-primary">Detalhes do Envio do E-mail</h3>
    </div>
    <ul class="list-group">
      <li class="list-group-item">Ocorrido em: <strong>{{ carimboEmailEnvio.ocorridoEm }}</strong></li>
      <li class="list-group-item">Carimbo (base64): <pre id="carimbo">{{ carimboEmailEnvio.carimbo }}</pre></li>
      <li class="list-group-item">Conteúdo: <pre class="carimbo">{{ carimboEmailEnvio.conteudo }}</pre></li>
      <li class="list-group-item">Hash: <strong>{{ carimboEmailEnvio.hashAssinado }}</strong></li>
      <li class="list-group-item">Serial: <strong>{{ carimboEmailEnvio.serial }}</strong></li>
      <li class="list-group-item">Emitido Por: <a href="https://www.documentoeletronico.com.br/" target="_blank"><strong>{{ carimboEmailEnvio.emitidoPor }}</strong></a></li>
      <li class="list-group-item">Algoritmo: <strong>{{ carimboEmailEnvio.algoritimo }}</strong></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'AppInfoEmailQualisoftSendDetails',

  props: {
    carimboEmailEnvio: {
      type: Object
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-qualisoft/InfoEmailQualisoftSendDetails.vue